/** Devices signed in as you, and the tablets on the wall. */

export interface MobileDeviceView {
  id: string
  deviceId: string
  platform: string
  model: string | null
  appVersion: string | null
  pushTransport: string | null
  pushRegistered: boolean
  lastSeenAt: string | null
  lastIp: string | null
  revokedAt: string | null
  revokedReason: string | null
  current: boolean
}

export interface KioskView {
  id: string
  name: string
  locationId: string
  expiresAt: string
  lastUsedAt: string | null
  revokedAt: string | null
  revokedReason: string | null
  usable: boolean
}

export interface KioskCreated {
  kiosk: KioskView
  /** Readable once. Only its hash is stored. */
  token: string
  note: string
}

export const PLATFORM_LABELS: Record<string, string> = {
  ANDROID: 'Android',
  IOS: 'iPhone or iPad',
  WEB: 'Browser',
  OTHER: 'Other',
}
